import axios from "../axios"

const getRequests = (params = null) => {
    return axios.get(`/applicant/request/list`, { params: params })
        .then(response => response.data)
}

const getRequest = (id) => {
    return axios.get(`/applicant/request/${id}`)
        .then(response => response.data.data)
}

export default {
    getRequests,
    getRequest,
};